import React, { memo } from 'react';

import { useTranslation } from '@cx-modules/i18n-provider';
import { type Repub } from '@cx-modules/types';

import { StartTime } from '../StartTime';

import { InPlayBadge, InPlayTimeWrapper, TimeColumnWrapper, Wrapper } from './style';

interface TimeProps {
  inRunning?: boolean;
  repub: Repub;
  startTime: string;
}

const Time = ({ inRunning, repub, startTime }: TimeProps) => {
  const { t } = useTranslation('label');
  const liveLabel = t('CX_MATCHES_COUPON_LIVE');

  return (
    <TimeColumnWrapper>
      <Wrapper aria-hidden={inRunning ? true : undefined} style={inRunning ? { visibility: 'hidden' } : undefined}>
        <StartTime repub={repub} startTime={startTime} />
      </Wrapper>
      <InPlayTimeWrapper
        aria-hidden={!inRunning ? true : undefined}
        style={!inRunning ? { visibility: 'hidden' } : undefined}
      >
        <InPlayBadge aria-label={liveLabel} role="status">
          {liveLabel}
        </InPlayBadge>
      </InPlayTimeWrapper>
    </TimeColumnWrapper>
  );
};

export default memo(Time);
